import { render, staticRenderFns } from "./Configuration_OPCUA.vue?vue&type=template&id=e78c2310&scoped=true&"
import script from "./Configuration_OPCUA.vue?vue&type=script&lang=js&"
export * from "./Configuration_OPCUA.vue?vue&type=script&lang=js&"
import style0 from "./Configuration_OPCUA.vue?vue&type=style&index=0&id=e78c2310&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78c2310",
  null
  
)

export default component.exports